/** Tracks which kid↔peer chat is currently open in this browser tab. */

export type OpenMessageChat = {
  kidProfileId: string;
  peerUserId: string;
};

let openChat: OpenMessageChat | null = null;

export const NOTIFICATIONS_CHANGED_EVENT = 'tinywins:notifications-changed';
export const OPEN_MESSAGE_CHAT_EVENT = 'tinywins:open-message-chat';

export function getOpenMessageChat(): OpenMessageChat | null {
  return openChat;
}

export function setOpenMessageChat(next: OpenMessageChat | null): void {
  const prev = openChat;
  const same =
    (prev?.kidProfileId || null) === (next?.kidProfileId || null) &&
    (prev?.peerUserId || null) === (next?.peerUserId || null);
  if (same) return;
  openChat = next;
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(OPEN_MESSAGE_CHAT_EVENT, { detail: next }));
  }
}

export function emitNotificationsChanged(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(NOTIFICATIONS_CHANGED_EVENT));
}

export function isMessageNotificationForOpenChat(n: {
  notificationType?: string | null;
  fromUserId?: string | null;
  kidProfileId?: string | null;
  payload?: unknown;
}): boolean {
  if (!openChat) return false;
  if (n.notificationType !== 'MESSAGE_RECEIVED') return false;
  const payload = n.payload as {
    kind?: string;
    fromUserId?: string | null;
    kidProfileId?: string | null;
    orgTeam?: boolean;
  } | null;
  const fromId = payload?.fromUserId || n.fromUserId || null;
  const kidId = payload?.kidProfileId || n.kidProfileId || null;
  if (fromId !== openChat.peerUserId) return false;
  // Org-team DMs have no kid — match open org-team chat.
  if (openChat.kidProfileId === 'org-team') {
    return !kidId || kidId === 'org-team' || payload?.orgTeam === true;
  }
  return kidId === openChat.kidProfileId;
}
